"use client";

import cnBind from "classnames/bind";

import LOGO from "@/shared/assests/svg/logo.svg";
import { Routes } from "@/shared/constants/Routing";
import { CustomImage } from "@/shared/ui/CustomImage";

import styles from "./Logo.module.scss";

const cx = cnBind.bind(styles);
type TLogo = {
    isFooter?: boolean;
};
export const Logo = ({ isFooter = false }: TLogo) => {
    return (
        <a href={Routes.HOME} className={cx("logo")} aria-label="Tezam — на главную">
            <CustomImage width={isFooter ? 88 :106} height={isFooter ? 27 :32} src={LOGO as string} alt="lmg" className={cx("image", { isFooter })} />
        </a>
    );
};
